export default function StopWorking() {
  return (
    <div className="stop-working">
      <div>
        <h3>Đang chờ duyệt !</h3>
        <h3>Bạn chưa được duyệt làm đại lý.</h3>
      </div>
    </div>
  );
}
